import { render, staticRenderFns } from "./Uploader.vue?vue&type=template&id=1a2fb22a&scoped=true&"
import script from "./Uploader.vue?vue&type=script&lang=ts&"
export * from "./Uploader.vue?vue&type=script&lang=ts&"
import style0 from "./Uploader.vue?vue&type=style&index=0&id=1a2fb22a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a2fb22a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
